import { HeaderContainer, ButtonContainer, Subtitle } from "./Header.styled";
import { Typography, Button } from "@ann/web-components";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const handleNewPrompt = () => {
    navigate("/v2/pms/config/new");
  };

  return (
    <HeaderContainer>
      <div>
        <Typography category="title" size="large" weight="bold">
          Prompt Management
        </Typography>
        <Subtitle>
          <Typography category="body" size="medium" weight="regular">
            Craft, organize, and manage your custom prompts all in one place.
          </Typography>
        </Subtitle>
      </div>
      <ButtonContainer>
        <Button
          icon=""
          iconLeft=""
          iconRight="plus"
          label="Create"
          size="medium"
          type="gradient"
          onClick={handleNewPrompt}
        />
      </ButtonContainer>
    </HeaderContainer>
  );
};

export default Header;
